import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastMessageOptions } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { NAV_ERROR_TOAST_KEY, NavigationErrorRecoveryService } from '../../services/navigation-error-recovery.service';

@Component({
  selector: 'inpla-navigation-error-toast',
  imports: [Toast, ButtonModule, TranslatePipe],
  templateUrl: './navigation-error-toast.component.html',
  styleUrl: './navigation-error-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationErrorToastComponent {
  private readonly recovery = inject(NavigationErrorRecoveryService);

  public readonly toastKey = NAV_ERROR_TOAST_KEY;

  public onReload(message: ToastMessageOptions): void {
    const targetUrl = (message.data as { targetUrl?: unknown } | undefined)?.targetUrl;
    this.recovery.reloadTo(typeof targetUrl === 'string' ? targetUrl : '/');
  }
}
